<!--test.vue-->
<template>
  <div class="qk-text" v-html="filterText(text)"></div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  export default {
    name: 'QkText', // 这个名字很重要，它就是未来的标签名<qk-text></qk-text>
    props: {
      text: {
        type: String,
        default: '这是一段文字'
      }
    },
    ...mapState({
      projectData: state => state.editor.projectData,
      activeElementUUID: state => state.editor.activeElementUUID
    }),
    data(){
      return {
        str: "",
        edit: false,
        defaultStyle: {
          height: 40
        }
      }
    },
    methods: {
      filterText(text) {
        if (text.indexOf('--displayNumber--') != -1) {
          return text.replace('--displayNumber--', 'xxxx')
        }
        if (text.indexOf('--companyName--') != -1) {
          return text.replace('--companyName--', '公司名称')
        }
        if (text.indexOf('--productName--') != -1) {
          return text.replace('--productName--', '展品名称')
        }
        return text;
      },
      focusText() {
        this.$refs.textarea.focus();
        this.edit = true;
      },
      input(e) {
        console.log(e);
        if (e.inputType == 'deleteContentBackward') {
          this.text = this.text.substring(0, basic.length - 1);
        }
        if (e.inputType == 'insertText') {
          this.text = this.text + e.data;
        }
        if (e.inputType == 'insertCompositionText' && /.*[\u4e00-\u9fa5]+.*/.test(e.data)) {
          // 中文
          this.text = this.text + e.data;
        }
      },
      blur() {

      }
    }
  }
</script>

<style lang="scss" scoped>
.qk-text-textarea {
  opacity: 0;
}
.cursor {
  animation: cursor 1s ease infinite;
}
@keyframes cursor {
  from {
    opacity: 0;
  };
  50% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.qk-text {
  white-space: pre-wrap;
}
</style>
